import { IGraphConfig } from '../model/graph-configs/graph-config';
import { IThingie } from '../model/thingie/thingie';
import { deepCopySync } from './deep-copy';

export type GraphConfigWithDashboardFlag = IGraphConfig & { isDashboardConfig: boolean };

/**
 * Takes a thingie and returns it's default graph configs,
 * if any.
 *
 * The returned list will contain dashboard card configurations,
 * if any exist.
 *
 * @param thingie The thingie to obtain the graph configurations from
 * @returns The thingie's graph configurations containing the information
 *   if they are dashboard card configs or not as the `isDashboardConfig` flag.
 */
export async function extractDefaultGraphConfigsFromThingie(
  thingie: IThingie,
): Promise<GraphConfigWithDashboardFlag[]> {
  const defaultConfigs: GraphConfigWithDashboardFlag[] = [
    ...deepCopySync(thingie.defaultGraphConfigs)
      .map(g => ({ ...g, isDashboardConfig: false })),
    ...(deepCopySync(thingie.defaultDashboardCardGraphConfigs) ?? [])
      .map(g => ({ ...g, isDashboardConfig: true }))
  ];

  return defaultConfigs;
}
